'use strict';
import * as $j_app$002edata$002e$002dAccepted$002dRequest$002dProvided$002dE$002dP$002dS$002dCode$0024 from "./app.data.-Accepted-Request-Provided-E-P-S-Code$.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$7() {
}
export { $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$7 as $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$7 };
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$7.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$7.prototype.constructor = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$7;
/** @constructor */
function $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$7() {
}
export { $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$7 as $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$7 };
$h_Lapp_api_DrugRequestsAcceptedListItem$$anon$7.prototype = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$7.prototype;
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$7.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$7.prototype.apply__O = (function() {
  return $j_app$002edata$002e$002dAccepted$002dRequest$002dProvided$002dE$002dP$002dS$002dCode$0024.$m_Lapp_data_AcceptedRequestProvidedEPSCode$Provided$().derived$Schema__Lsttp_tapir_Schema();
});
var $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestsAcceptedListItem$$anon$7, "app.api.DrugRequestsAcceptedListItem$$anon$7", ({
  Lapp_api_DrugRequestsAcceptedListItem$$anon$7: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$7 as $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$7 };
//# sourceMappingURL=app.api.-Drug-Requests-Accepted-List-Item$$anon$7.js.map
